import { Card, Col, DatePicker, Empty, Row, Select, Table } from 'antd';
import gql from 'graphql-tag';
import * as moment from 'moment';
import React, { Component } from 'react';
import { Query } from 'react-apollo';

import { DateRange } from '../../types/base';
import { SpeechTypeText } from '../../types/speech';
import { Lesson, Statistics, TeachingPoint, TeachingPointType, UserData } from './Enrollment';

interface State {
  speechDateRange: DateRange;
  lessonIds?: string[];
  queryLessonIds?: string[];
  teachingPointIds?: number[];
  isCourseSelectionOpen: boolean;
}
interface Props {
  userId: number;
  enrollmentId: number;
  lessons: Lesson[];
  teachingPoints: TeachingPoint[];
}
const Option = Select.Option;

export const userEnrollmentsSpeechQuery = gql`
  query getUserEnrollments(
    $ids: [ID]
    $enrollmentIds: [Int]
    $speechDateRange: DateRange!
    $lessonIds: [Int]
    $teachingPointIds: [Int]
  ) {
    users(ids: $ids) {
      enrollments(ids: $enrollmentIds) {
        id
        enrollmentReport(
          speechDateRange: $speechDateRange
          lessonIds: $lessonIds
          teachingPointIds: $teachingPointIds
        ) {
          lessonNames
          knowledgePoints {
            name
            highestAccuracy
            allAccuracies
            lessonName
            speech {
              content
              type
            }
          }
        }
      }
    }
  }
`;

export class EnrollmentReport extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isCourseSelectionOpen: false,
      speechDateRange: {
        from: moment().startOf('day').toDate(),
        to: moment().endOf('day').toDate(),
      },
      lessonIds: [],
    };
  }

  render() {
    const { userId, enrollmentId, lessons, teachingPoints } = this.props;
    const { queryLessonIds, speechDateRange, lessonIds, teachingPointIds } = this.state;

    return (
      <>
        <Query<UserData>
          query={userEnrollmentsSpeechQuery}
          variables={{
            speechDateRange,
            teachingPointIds,
            lessonIds: queryLessonIds,
            ids: [userId],
            enrollmentIds: [enrollmentId],
          }}
        >
          {({ loading, error, data }) => {
            if (error) return <div>{error.message}</div>;
            if (loading) return <div>loading...</div>;
            if (!data) {
              // @ts-ignore
              return <Empty />;
            }
            const [user] = (data && data.users) || [null];
            const [enrollment] = user && user.enrollments;
            return (
              <>
                <Card title="话术反馈" bordered={false}>
                  <Card>
                    <Row gutter={24}>
                      <Col span={2} style={{ textAlign: 'right' }}>
                        课时:
                      </Col>
                      <Col span={6}>
                        <Select
                          showSearch
                          allowClear
                          mode="multiple"
                          value={lessonIds}
                          open={this.state.isCourseSelectionOpen}
                          style={{ width: 200 }}
                          placeholder="选择课时"
                          optionFilterProp="children"
                          onFocus={() => {
                            this.setState({
                              isCourseSelectionOpen: true,
                            });
                          }}
                          onBlur={() => {
                            this.setState({
                              isCourseSelectionOpen: false,
                            });
                          }}
                          onChange={(value: string[]) => {
                            if (value.length > 2) {
                              return;
                            }
                            const selectedStartCourses = Number(value[0]);
                            const selectedEndCourses = Number(value[1]);
                            let selectedCourses: string[] = [];
                            if (!selectedStartCourses) {
                              this.setState({
                                lessonIds: [],
                              });
                              return;
                            }

                            this.setState({
                              lessonIds: [selectedStartCourses.toString()],
                            });
                            if (selectedEndCourses) {
                              for (
                                let course: number = selectedStartCourses;
                                course <= selectedEndCourses;
                                course += 1
                              ) {
                                const conversionCourseType = String(course);
                                selectedCourses.push(conversionCourseType);
                              }
                              this.setState({
                                lessonIds: selectedCourses,
                                isCourseSelectionOpen: false,
                                queryLessonIds: selectedCourses,
                              });
                            }
                            selectedCourses = [];
                          }}
                          filterOption={(input, option) => {
                            const lessonName = option && option.props && option.props.children;
                            return (
                              typeof lessonName === 'string' &&
                              lessonName.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            );
                          }}
                        >
                          {lessons.map(lesson => {
                            return (
                              <Option value={lesson.id} key={`${lesson.id}`}>
                                {lesson.name}
                              </Option>
                            );
                          })}
                        </Select>
                      </Col>
                      <Col span={2} style={{ textAlign: 'right' }}>
                        知识点:
                      </Col>
                      <Col span={6}>
                        <Select
                          showSearch
                          allowClear
                          mode="multiple"
                          style={{ width: 200 }}
                          placeholder="选择知识点"
                          defaultValue={teachingPointIds}
                          optionFilterProp="children"
                          onChange={(value: number[]) => {
                            this.setState({
                              teachingPointIds: value,
                            });
                          }}
                          filterOption={(input, option) => {
                            const lessonName = option && option.props && option.props.children;
                            return (
                              typeof lessonName === 'string' &&
                              lessonName.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            );
                          }}
                        >
                          {teachingPoints
                            .filter(techingPoint => techingPoint.type === TeachingPointType.KNOWLEDGE_POINT)
                            .map(techingPoint => {
                              return (
                                <Option value={techingPoint.id} key={`${techingPoint.id}`}>
                                  {techingPoint.name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Col>
                      <Col span={2} style={{ textAlign: 'right' }}>
                        时间:
                      </Col>
                      <Col span={6}>
                        <DatePicker.RangePicker
                          value={[moment(speechDateRange.from), moment(speechDateRange.to)]}
                          ranges={{
                            今天: [moment(), moment()],
                            本周: [moment().startOf('week'), moment().endOf('week')],
                            上周: [
                              moment().startOf('week').subtract(1, 'week'),
                              moment().endOf('week').subtract(1, 'week'),
                            ],
                          }}
                          onChange={dates =>
                            this.setState({
                              speechDateRange: {
                                from: moment(dates[0]).startOf('day').toDate(),
                                to: moment(dates[1]).endOf('day').toDate(),
                              },
                            })
                          }
                        />
                      </Col>
                    </Row>
                  </Card>
                  <Card title="所学课程">{enrollment.enrollmentReport.lessonNames.join('，')}</Card>
                  <Table dataSource={enrollment.enrollmentReport.knowledgePoints} pagination={false} loading={loading}>
                    <Table.Column width={'10%'} title="知识点" dataIndex="name" key="speechKnowledgeName" />
                    <Table.Column<Statistics>
                      sorter={(a, b) => {
                        if (a.highestAccuracy === 0) return 1; // Return 1 so that b goes first
                        if (b.highestAccuracy === 0) return -1; // Return -1 so that a goes first
                        return a.highestAccuracy - b.highestAccuracy;
                      }}
                      width={'10%'}
                      title="最高正确率"
                      dataIndex="highestAccuracy"
                      key="speechHighestAccuracy"
                      render={highestAccuracy => `${(highestAccuracy * 100).toFixed(0)}%`}
                    />
                    <Table.Column
                      width={'12%'}
                      title="所有正确率"
                      dataIndex="allAccuracies"
                      key="speechAllAccuracies"
                      render={(allAccuracies: number[]) =>
                        allAccuracies.map((item: number, index: number) => {
                          let content = `${(item * 100).toFixed(0)}%`;
                          if (index < allAccuracies.length - 1) {
                            content += '-';
                          }
                          return content;
                        })
                      }
                    />
                    <Table.Column width={'10%'} title="知识点对应课时" dataIndex="lessonName" key="lessonName" />
                    <Table.Column
                      width={'8%'}
                      title="高/低"
                      dataIndex="speech.type"
                      key="speechType"
                      render={type => SpeechTypeText[type]}
                    />
                    <Table.Column
                      width={'50%'}
                      title="内容"
                      dataIndex="speech.content"
                      key="speechContent"
                      render={item => item || '-'}
                    />
                  </Table>
                </Card>
              </>
            );
          }}
        </Query>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/enrollment/EnrollmentReport.tsx